import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';

const SmsTemplateList: React.FC = () => {
    const { t } = useTranslation();

    // Filter the list on the division selected in the settings menu
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const divisionParams = !isEnvironmentSelected && selectedDivision ? { 'division_scope': selectedDivision.id } : {};

    // Specify the options of this list
    const query = {
        endpoint: 'get_sms_template_list',
        defaultParams: { 'deleted': false, ...divisionParams },
        object: 'sms_template'
    }
    const objectName = 'sms.sms_template.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'
    const isPaginated = false

    // Open the library page for new templates and the template page for rows
    const openPageUrl = 'settings/features/sms/template-library';
    const onRowClick = 'detailPage'
    const detailPageUrl = 'settings/features/sms/template';

    // Specify the columns of this list
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'name', label: 'sms.sms_template.name_label' },
        {
            width: '1fr',
            field: 'message_type',
            label: 'sms.sms_template.message_type_label',
            render: (_, row: any) => <>{t(`sms_template.message_type.${row.message_type}`)}</>,
        },
    ];

    return (
        <AbstractList
            key={!isEnvironmentSelected && selectedDivision ? selectedDivision.id : 'environment'}
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            openPageUrl={openPageUrl}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
        />
    );
};

export default SmsTemplateList;
